import React from 'react';

import { Image, Platform } from 'react-native';

import { ReplayIcon } from 'assets/images';

import { COLOR } from 'utils/colors';

import styles from './styles';

type Props = {
    playing?: boolean;
    testID?: string;
};

function EpgReplayIcon({ playing, testID }: Props) {
    if (Platform.OS === 'web') {
        return (
            <ReplayIcon
                testID={testID}
                fill={playing ? COLOR.background : COLOR.NEUTRAL}
                style={styles.root}
            />
        );
    }

    return (
        <Image
            testID={testID}
            source={{
                uri: playing ? 'icon_epg_replay_black' : 'icon_epg_replay',
            }}
            style={styles.root}
        />
    );
}

export default React.memo(EpgReplayIcon);
